import api from './api';

/**
 * Get all pools with filtering and pagination
 */
export const getPools = async (params = {}) => {
  try {
    const response = await api.get('/admin/shipping/pools/', {
      params,
      requiresAuth: true
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || 'Failed to fetch pools');
  }
};

/**
 * Get pool details
 */
export const getPoolDetails = async (poolSid) => {
  try {
    const response = await api.get(`/admin/shipping/pools/${poolSid}/`, {
      requiresAuth: true
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || 'Failed to fetch pool details');
  }
};

/**
 * Create a new pool
 */
export const createPool = async (data) => {
  try {
    const response = await api.post('/admin/shipping/pools/create/', data, {
      requiresAuth: true
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || 'Failed to create pool');
  }
};

/**
 * Update pool status
 */
export const updatePoolStatus = async (poolSid, status, trackingNumber = null, notes = null) => {
  try {
    const response = await api.patch(
      `/admin/shipping/pools/${poolSid}/status/`,
      { status, tracking_number: trackingNumber, notes },
      { requiresAuth: true }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || 'Failed to update pool status');
  }
};

/**
 * Update pool costs
 */
export const updatePoolCosts = async (poolSid, totalShippingCost) => {
  try {
    const response = await api.patch(
      `/admin/shipping/pools/${poolSid}/costs/`,
      { total_shipping_cost: totalShippingCost },
      { requiresAuth: true }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || 'Failed to update pool costs');
  }
};

/**
 * Get pool settings
 */
export const getPoolSettings = async () => {
  try {
    const response = await api.get('/admin/shipping/pools/settings/', {
      requiresAuth: true
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || 'Failed to fetch pool settings');
  }
};

/**
 * Update pool settings
 */
export const updatePoolSettings = async (settings) => {
  try {
    const response = await api.patch(
      '/admin/shipping/pools/settings/',
      { settings },
      { requiresAuth: true }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || 'Failed to update pool settings');
  }
};

/**
 * Get pool statistics
 */
export const getPoolStats = async (days = 30) => {
  try {
    const response = await api.get('/admin/shipping/pools/stats/', {
      params: { days },
      requiresAuth: true
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || 'Failed to fetch pool statistics');
  }
};

/**
 * Process a ready pool: create combined package, select shipping, calculate costs
 */
export const processPool = async (poolSid, data) => {
  try {
    const response = await api.post(
      `/admin/shipping/pools/${poolSid}/process/`,
      data,
      { requiresAuth: true }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || 'Failed to process pool');
  }
};

/**
 * Get all packages in a pool for traceability
 */
export const getPoolPackages = async (poolSid) => {
  try {
    const response = await api.get(`/admin/shipping/pools/${poolSid}/packages/`, {
      requiresAuth: true
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || 'Failed to fetch pool packages');
  }
};
